module.exports = {"330226001":"跃龙街道","330226002":"桃源街道","330226003":"梅林街道","330226004":"桥头胡街道","330226101":"长街镇","330226102":"力洋镇","330226104":"一市镇","330226105":"岔路镇","330226106":"前童镇","330226107":"桑洲镇","330226108":"黄坛镇","330226109":"大佳何镇","330226110":"强蛟镇","330226111":"西店镇","330226112":"深甽镇","330226200":"胡陈乡","330226201":"茶院乡","330226202":"越溪乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/330226.json
// module id = 1065
// module chunks = 0